'use strict'

export default function (): void {
  const bigImgContainer = document.querySelector<HTMLElement>('.zoomed__images')
  const wrapper = document.querySelector<HTMLElement>('.product__thumbnails')

  if (!bigImgContainer || !wrapper) {
    return
  }

  if (wrapper) {
    wrapper.addEventListener('mouseleave', () => {
      bigImgContainer.classList.remove('visible')
    })
    const images: Record<string, HTMLImageElement> = {}
    const positions = [50, 177, 304, 411, 431, 451]
    wrapper.querySelectorAll('img').forEach((el, key) => {
      el.addEventListener('mouseenter', (e) => {
        const target = e.currentTarget as HTMLImageElement
        const src = target.src

        bigImgContainer.classList.add('visible')
        bigImgContainer.style.left = positions[key] + 'px'
        if (images[src]) {
          bigImgContainer.innerHTML = ''
          bigImgContainer.appendChild(images[src] as HTMLImageElement)
        } else {
          const img = document.createElement('img')
          img.src = target.dataset.bigimage as string
          bigImgContainer.innerHTML = ''
          bigImgContainer.appendChild(img)
          images[src] = img
        }
      })
    })
  }
}
